{
  "tcGenerator": "Id Card Generator",
  "pendingServices": "Pending services",
  "serviceId": "Service Id",
  "uploadExcel": "Upload excel",
  "download": "Download",
  "or": "Or",
  "visit": "Visit student page",
  "preview": "Template preview",
  "cancelTCGeneration": "Are you sure you want to cancel the Id card generation ?",
  "editServices": "Are you sure you want to edit the selected service ?",
  "editMessage": "  If you are proceeding with edit, your current job will get removed. You will get to download one excel sheet were you can edit the data and re-upload the file",
  "yes": "Yes",
  "proceed": "Proceed",
  "no": "No",
  "excelUploading": "Please wait excel uploading...",
  "errorLocation": "We found some error in the excel sheet that you tried to upload. The error positions are as followed:",
  "messageUploadAgain": "Please make the modification try uploading again.",
  "uploadSuccessfully": "Excel uploaded successfully",
  "uploadSuccess": "Your Excel file has been successfully uploaded. We are now generating your id card. Please wait, and in the meantime, you can track the status using the provided job ID. Thank you for your patience!",
  "jobId": "Job Id",
  "inProgress": "In progress",
  "pending": "Pending",
  "view": "View",
  "cancel": "Cancel",
  "count": "Count",
  "cancelled": "Cancelled",
  "edit": "Edit",
  "uploadFailed": "Oops!! Can’t upload your document",
  "generatingMessage": "We are now generating your id card. Please wait, and in the meantime, you can track the status using the provided job ID. Thank you for your patience!",
  "ok": "Ok",
  "column": "Column :",
  "row": "Row :",
  "close": "Close",
  "openTC": "Open Id card",
  "tcGenerationUnderProcess": "Id card generation under process...",
  "registrationId": "Registration id",
  "name": "Name",
  "class": "Class",
  "section": "Section",
  "errorMessage": "An unknown error occurred.",
  "error": "error",
  "success": "success",
  "sampleFormatError": "Sample format not available.",
  "fileDownloadMessage": "File downloaded.",
  "fileUploadErrorMessage": "Please select file",
  "fileSize": 50,
  "lang": "en",
  "messageForTc": "Are you sure you want to generate the id cards for selected student ?",
  "fileFormatError": "Please upload correct file format."
}
